<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="data"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:item.color="{ item }">
      <v-chip
        :color="item.color"
        style="width: 50px;"
      />
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.annotations') }}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        />
        <div class="flex-grow-1" />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="mr-4"
          style="max-width: 250px;"
        />
        <v-dialog
          v-model="deleteDialog"
          persistent
        >
          <v-card>
            <v-card-title class="headline">
              {{ $vuetify.lang.t('$vuetify.generalDeleteMessage') }}
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="deleteDialog = false"
              >
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="deleteAction"
              >
                {{ $vuetify.lang.t('$vuetify.delete') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog"
          persistent
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-on="on"
            >
              {{ $vuetify.lang.t('$vuetify.newItem') }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>{{ $vuetify.lang.t('$vuetify.color') }}</p>
                    <v-color-picker
                      v-model="editedItem.color"
                      hide-inputs
                      mode.sync="hex"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn
                color="secondary"
                text
                @click="close"
              >
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </v-btn>
              <v-btn
                color="secondary"
                text
                @click="save"
              >
                {{ $vuetify.lang.t('$vuetify.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      permissionsKey: 9,
      search: '',
      dialog: false,
      deleteDialog: false,
      deletedItem: {},
      data: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        color: '#796efd',
      },
      defaultItem: {
        name: '',
        color: '#796efd',
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.newItem') : this.$vuetify.lang.t('$vuetify.editItem');
    },
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$vuetify.lang.t('$vuetify.text'), value: 'name' },
        { text: this.$vuetify.lang.t('$vuetify.color'), value: 'color' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllAnnotations();
      this.data = result;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.data.findIndex((i) => { return i.id === this.editedItem.id; });
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async deleteAction() {
      const index = this.data.findIndex((i) => { return i.id === this.deletedItem.id; });
      const result = await apiUtil.deleteAnnotationById(this.deletedItem);
      if (result) {
        this.data.splice(index, 1);
      }
      this.deleteDialog = false;
    },
    async save() {
      const response = await apiUtil.saveAnnotation(this.editedItem);
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], this.editedItem);
      } else {
        this.data.push(response);
      }

      this.close();
    },
  },
};
</script>
